'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { useBranchId, useFunnelStepId } from '@/features/funnel/state/funnel/Context/hooks';
export function usePageActionForBranch(t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    actionSection
  } = t1;
  const stepId = useFunnelStepId();
  const branchId = useBranchId();
  let t2;
  if ($[2] !== branchId || $[3] !== stepId) {
    t2 = {
      page_branch_name: branchId,
      page_name: stepId
    };
    $[2] = branchId;
    $[3] = stepId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== actionSection || $[6] !== t2) {
    t3 = {
      actionSection,
      additionalAttributes: t2
    };
    $[5] = actionSection;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return usePageAction(t3);
}